<template>
  <div class="charts-detail">
    <div class="title">{{ title }}</div>
    <span
      @click="chooseLabelFn(item.id)"
      :class="{ 'active-chart-table': selectData == item.id }"
      class="btn-option"
      v-for="item in btn"
      :key="item.id"
      >{{ item.label }}</span
    >
  </div>
</template>
<script>
export default {
  name: 'title-btn',
  props: {
    title: {
      default: '',
      type: String,
    },
    btn: {
      type: Array,
      default: () => [{ label: '', id: '' }],
    },
  },
  data() {
    return {
      selectData: '1',
    };
  },
  methods: {
    chooseLabelFn(val) {
      this.selectData = val;
      this.$emit('selectChange', this.selectData);
    },
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.charts-detail {
  margin-bottom: 30px;
  .title {
    color: #8c8c8c;
    margin-bottom: 17px;
  }
  .btn-option {
    display: inline-block;
    width: auto;
    padding: 0 10px;
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    margin-right: 16px;
    cursor: pointer;
    line-height: 32px;
    text-align: center;
  }
  .active-chart-table {
    color: $--color-primary;
    background: #fffaed;
    border: 1px solid #ffc973;
    cursor: initial;
  }
}
</style>
